import { render } from "./DanhSachChip.vue?vue&type=template&id=6c9bbc59&scoped=true"
import script from "./DanhSachChip.vue?vue&type=script&lang=js"
export * from "./DanhSachChip.vue?vue&type=script&lang=js"

import "./DanhSachChip.vue?vue&type=style&index=0&id=6c9bbc59&lang=scss&scoped=true"

import exportComponent from "E:\\SonPhat\\Project\\BanVe\\banvetaimaypos_fe\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c9bbc59"]])

export default __exports__